import React from 'react'
import NavigationBar from '../General/NavigationBar'
import Notification from '../General/Notification'
import TransactionCard from './TransactionCard2'
import FloatingIcon from '../General/FloatingIcon'
import FixedButton from '../General/FixedButton'
import Navbar from './Navbar'

function Rassemble() {
  return (
    <div>
      <NavigationBar/>
      <Notification/>
      <TransactionCard/>
      <FloatingIcon/>
      <FixedButton/>
      <Navbar/>
    </div>
  )
}

export default Rassemble